/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SimulationChannel } from "./SimulationChannel";
import {
  SimulationChannelFromJSON,
  SimulationChannelFromJSONTyped,
  SimulationChannelToJSON,
  SimulationChannelToJSONTyped,
} from "./SimulationChannel";

/**
 *
 * @export
 * @interface PaginatedSimulationChannelList
 */
export interface PaginatedSimulationChannelList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<SimulationChannel>;
}

/**
 * Check if a given object implements the PaginatedSimulationChannelList interface.
 */
export function instanceOfPaginatedSimulationChannelList(
  value: object
): value is PaginatedSimulationChannelList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedSimulationChannelListFromJSON(json: any): PaginatedSimulationChannelList {
  return PaginatedSimulationChannelListFromJSONTyped(json, false);
}

export function PaginatedSimulationChannelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedSimulationChannelList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(SimulationChannelFromJSON),
  };
}

export function PaginatedSimulationChannelListToJSON(json: any): PaginatedSimulationChannelList {
  return PaginatedSimulationChannelListToJSONTyped(json, false);
}

export function PaginatedSimulationChannelListToJSONTyped(
  value?: PaginatedSimulationChannelList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(SimulationChannelToJSON),
  };
}
